import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Grid, Button } from "@mui/material";
import { hasEditAccess } from "services/utils";
import { useAuth } from "context/authContext";
import SetupView from "./components/SetupView";
import EmployeesView from "./components/EmployeesView";
import PeriodsRunsView from "./components/PeriodsRunsView";
import MDBox from "components/MDBox";
import { buttonStyles } from "services/utils";
const PayrollPage = () => {
  const { t } = useTranslation();
  const { employee, modules } = useAuth();
  const [view, setView] = useState(0);
  const canEdit = hasEditAccess(modules, "Payroll", employee);

  const buttons = [
    { label: t("admin.payroll.tabs.setup"), viewIndex: 0 },
    { label: t("admin.payroll.tabs.employees"), viewIndex: 1 },
    { label: t("admin.payroll.tabs.periodsAndRuns"), viewIndex: 2 },
  ];

  return (
    <MDBox>
      <Stack pb={2}>
        <Grid container spacing={1} sx={{ justifyContent: { xs: "center", md: "flex-start" } }}>
          {buttons.map(({ label, viewIndex }) => (
            <Grid item xs={12} sm={6} md="auto" key={viewIndex}>
              <Button
                sx={{
                  ...buttonStyles(view === viewIndex),
                  width: { xs: "100%", md: "auto" },
                }}
                variant={view === viewIndex ? "contained" : "outlined"}
                onClick={() => setView(viewIndex)}
                color="primary"
              >
                {label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Stack>

      {view === 0 ? (
        <SetupView canEdit={canEdit} />
      ) : view === 1 ? (
        <EmployeesView canEdit={canEdit} />
      ) : (
        <PeriodsRunsView canEdit={canEdit} />
      )}
    </MDBox>
  );
};

export default PayrollPage;
